import { LogoBase } from './LogoBase'
import svgLogo from './logo.svg'

export function Logo() {
  return (
    <LogoBase
      sx={{
        '& .GcLogo-logo': {
          width: 'auto',
          height: { xs: '50px', md: '60px' },
          paddingLeft: { xs: '10px', md: 0 },
          marginTop: { xs: 0, md: '-5px' },
          marginRight: { xs: 0, md: '20px' },
          filter: (theme) => (theme.palette.mode === 'dark' ? 'invert(100%)' : 'none'),
        },
      }}
      image={{ alt: 'Windparadise', src: svgLogo, unoptimized: true }}
    />
  )
}
